module.exports = __webpack_public_path__ + "static/react2-d14e4fd3c8b856f05612643d6773e497.png";